/* eslint-disable */

/**
 * @file
 * Mobile carousel behaviour (mobile only).
 *
 */

(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.mobileCarousel = {
    attach: function (context) {
      $('.carousel-outer-container', context).each(function (index) {

        var $outer = $(this);
        const instanceNs = '.mobileCarousel' + index;

        if ($outer.find('.related-news-block').length > 0) {
          var $carouselContainer = $outer.find('.related-news-block .views-view-grid');
          $outer = $outer.parents('.layout-containter');
        } else {
          var $carouselContainer = $outer.children().first();
        }

        $outer.addClass('carousel-component');
        const $carouselTrack = $carouselContainer.children().first();
        const $carouselItems = $carouselTrack.children();

        if (!$carouselContainer.length || !$carouselTrack.length || !$carouselItems.length) {
          return;
        }

        let initialized = false;
        let $prev = null, $next = null, $pagination = null, $playPause = false;
        let currentIndex = 0;
        let itemCount = $carouselItems.length;
        let itemWidth = 0;
        let startX = 0, deltaX = 0, isDragging = false;
        let autoplay = false, autoplayInterval = 5000, autoplayTimer = null, resumeTimer = null, userPaused = false;
        let infinite = true;
        let cloneOffset = 0; // 1 when infinite clones are active

        const playIcon = '<svg class="icon icon-play" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg>';
        const pauseIcon = '<svg class="icon icon-pause" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';

        function updateSizes() {
          itemWidth = $carouselContainer.outerWidth();
          // Size all children including infinite clones
          $carouselTrack.children().each(function () {
            $(this).css({ 'flex-basis': itemWidth + 'px', 'max-width': itemWidth + 'px' });
          });
          setPositionByIndex(false);
        }

        function updatePaginationActive() {
          if (!$pagination) return;
          const realIndex = ((currentIndex % itemCount) + itemCount) % itemCount;
          $pagination.find('.carousel-dot').each(function (i) {
            $(this).attr('aria-current', i === realIndex ? 'true' : 'false');
          });
        }

        function setPositionByIndex(animate = true) {
          if (!$carouselTrack) return;
          if (!animate) {
            $carouselTrack.addClass('is-dragging');
            setTimeout(() => $carouselTrack.removeClass('is-dragging'), 20);
          }
          // cloneOffset is 1 when infinite clones are prepended, shifting all real items right by one
          const translateX = -(currentIndex + cloneOffset) * itemWidth;
          $carouselTrack.css('transform', 'translateX(' + translateX + 'px)');
          if ($prev && $next) {
            const atStart = !infinite && currentIndex <= 0;
            const atEnd = !infinite && currentIndex >= itemCount - 1;
            $prev.attr('aria-disabled', atStart ? 'true' : 'false');
            $next.attr('aria-disabled', atEnd ? 'true' : 'false');
          }
          updatePaginationActive();
        }

        function goTo(index) {
          if (infinite && itemCount > 1) {
            // Allow out-of-bounds temporarily so we animate through the clone
            currentIndex = index;
          } else {
            currentIndex = Math.max(0, Math.min(index, itemCount - 1));
          }
          setPositionByIndex();
        }

        function startAutoplay() {
          if (!autoplay || userPaused || itemCount <= 1) return;
          stopAutoplay();
          autoplayTimer = setInterval(() => {
            // In infinite mode, step through the clone so the loop animation plays
            goTo(infinite ? currentIndex + 1 : (currentIndex + 1) % itemCount);
          }, autoplayInterval);
          if ($playPause) { $playPause.html(pauseIcon).attr({ 'aria-pressed': 'false', 'aria-label': 'Pause autoplay' }); }
        }

        function stopAutoplay() {
          if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
          if ($playPause) { $playPause.html(playIcon).attr({ 'aria-pressed': 'true', 'aria-label': 'Start autoplay' }); }
        }

        function pauseForInteraction() {
          stopAutoplay();
          if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
          if (!userPaused) {
            resumeTimer = setTimeout(() => startAutoplay(), 6000);
          }
        }

        function createControls() {
          $prev = $('<button type="button" class="carousel-nav prev" aria-label="Previous" aria-disabled="' + (infinite ? 'false' : 'true') + '">&#x2039;</button>');
          $next = $('<button type="button" class="carousel-nav next" aria-label="Next" aria-disabled="false">&#x203A;</button>');
          $outer.append($prev, $next);

          $pagination = $('<div class="carousel-pagination" role="tablist" aria-label="Carousel pagination"></div>');
          for (let i = 0; i < itemCount; i++) {
            const $dot = $('<button class="carousel-dot" role="tab" aria-label="Slide ' + (i + 1) + '" tabindex="0"></button>');
            $dot.on('click' + instanceNs, () => { goTo(i); pauseForInteraction(); });
            $pagination.append($dot);
          }
          $outer.append($pagination);

          // $playPause = $('<button type="button" class="carousel-playpause" aria-pressed="false" aria-label="Pause autoplay">' + pauseIcon + '</button>');
          // $playPause.on('click' + instanceNs, () => {
          //   userPaused = !userPaused;
          //   if (userPaused) stopAutoplay(); else startAutoplay();
          // });
          // $carouselContainer.append($playPause);

          updatePaginationActive();
        }

        function destroyControls() {
          if ($prev) { $prev.off(instanceNs).remove(); $prev = null; }
          if ($next) { $next.off(instanceNs).remove(); $next = null; }
          if ($pagination) { $pagination.find('.carousel-dot').off(instanceNs); $pagination.remove(); $pagination = null; }
          if ($playPause) { $playPause.off(instanceNs).remove(); $playPause = null; }
        }

        function bindEvents() {
          $prev.on('click' + instanceNs, () => { goTo(currentIndex - 1); pauseForInteraction(); });
          $next.on('click' + instanceNs, () => { goTo(currentIndex + 1); pauseForInteraction(); });

          // Infinite loop: after animating into a clone, silently snap to the real counterpart
          $carouselTrack.on('transitionend' + instanceNs, function () {
            if (!infinite || itemCount <= 1) return;
            if (currentIndex <= -1) {
              // Animated onto prepended clone of last → jump to real last
              currentIndex = itemCount - 1;
              setPositionByIndex(false);
            } else if (currentIndex >= itemCount) {
              // Animated onto appended clone of first → jump to real first
              currentIndex = 0;
              setPositionByIndex(false);
            }
          });

          $carouselContainer.attr('tabindex', '0').on('keydown' + instanceNs, (e) => {
            if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex - 1); pauseForInteraction(); }
            else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex + 1); pauseForInteraction(); }
          });

          $carouselTrack.on('touchstart' + instanceNs + ' pointerdown' + instanceNs, (e) => {
            const point = e.originalEvent.touches ? e.originalEvent.touches[0] : e.originalEvent;
            startX = point.clientX; deltaX = 0; isDragging = true;
            $carouselTrack.addClass('is-dragging');
            pauseForInteraction();
          });
          $carouselTrack.on('touchmove' + instanceNs + ' pointermove' + instanceNs, (e) => {
            if (!isDragging) return;
            const point = e.originalEvent.touches ? e.originalEvent.touches[0] : e.originalEvent;
            deltaX = point.clientX - startX;
            const base = -(currentIndex + cloneOffset) * itemWidth;
            $carouselTrack.css('transform', 'translateX(' + (base + deltaX) + 'px)');
          });
          $carouselTrack.on('touchend' + instanceNs + ' pointerup' + instanceNs + ' pointercancel' + instanceNs, () => {
            if (!isDragging) return;
            isDragging = false;
            $carouselTrack.removeClass('is-dragging');
            if (Math.abs(deltaX) > (itemWidth * 0.15)) {
              if (deltaX < 0) goTo(currentIndex + 1); else goTo(currentIndex - 1);
            } else setPositionByIndex();
            startX = deltaX = 0;
          });

          $(window).on('resize' + instanceNs, () => {
            if (window.matchMedia('(max-width: 767px)').matches) updateSizes();
            else teardownCarousel();
          });
        }

        function unbindEvents() {
          $carouselContainer.off(instanceNs);
          $carouselTrack.off(instanceNs);
          $(window).off('resize' + instanceNs);
        }

        function initCarousel() {
          if (initialized) return;
          if (!window.matchMedia('(max-width: 767px)').matches) return;

          $carouselTrack.addClass('carousel-track');
          $carouselContainer.addClass('carousel-container');

          itemCount = $carouselItems.length;
          currentIndex = 0;

          // Set up infinite clones: prepend clone of last, append clone of first
          if (infinite && itemCount > 1) {
            cloneOffset = 1;
            $carouselTrack.prepend($carouselItems.last().clone().addClass('carousel-clone'));
            $carouselTrack.append($carouselItems.first().clone().addClass('carousel-clone'));
          }

          createControls();
          bindEvents();
          updateSizes();
          startAutoplay();

          initialized = true;
        }

        function teardownCarousel() {
          if (!initialized) return;
          destroyControls();
          unbindEvents();
          // Remove infinite clones and reset
          $carouselTrack.find('.carousel-clone').remove();
          cloneOffset = 0;
          $carouselTrack.css('transform', '');
          $carouselItems.each(function () { $(this).css({ 'flex-basis': '', 'max-width': '' }); });
          if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
          if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
          initialized = false;
        }

        if (window.matchMedia('(max-width: 767px)').matches) initCarousel();
        $(window).on('resize.mobileCarouselInit' + index, () => {
          if (window.matchMedia('(max-width: 767px)').matches) initCarousel();
          else teardownCarousel();
        });

      });
    }
  };

})(jQuery, Drupal, drupalSettings);
